import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://missionmap-lc.onrender.com/api/admin',
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  console.log("🔐 Attaching token:", token); // debug line
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
